const translations = {
	form: {
		header: {
			de: "Ergebnisse filtern nach:",
			en: "Filter entries:",
		},
		submitBtn: {
			de: "Suchen",
			en: "Search",
		},
		submitBtnAriaLabel: {
			de: "Jetzt suchen",
			en: "Search now",
		},
		resetBtn: {
			de: "Filter zurücksetzen",
			en: "Reset filter",
		},
		resetBtnAriaLabel: {
			de: "Filter zurücksetzen",
			en: "Reset filter",
		},
	},
	textInput: {
		label: {
			de: "Suchbegriff",
			en: "Search term",
		},
		placeholder: {
			de: "Suchbegriff eingeben",
			en: "Enter search term",
		},
	},
	listboxYear: {
		label: {
			de: "Jahr",
			en: "Year",
		},
		placeholder: {
			de: "Jahr auswählen",
			en: "Select year",
		},
	},
	listboxMonth: {
		label: {
			de: "Monat",
			en: "Month",
		},
		placeholder: {
			de: "Monat auswählen",
			en: "Select month",
		},
		labelDisabled: {
			de: "Bitte wählen Sie zuerst ein Jahr aus",
			en: "Please select a year first",
		},
	},
	listboxTopic: {
		label: {
			de: "Thema",
			en: "Topic",
		},
		placeholder: {
			de: "Thema auswählen",
			en: "Select topic",
		},
	},
	listboxTimespan: {
		label: {
			de: "Zeitraum",
			en: "Date range",
		},
		placeholder: {
			de: "Zeitraum auswählen",
			en: "Select date range",
		},
		options: {
			de: [ 'Keine Einschränkung', 'Letzte 2 Wochen', 'Letzter Monat', 'Letzte 3 Monate', 'Letztes Jahr' ],
			en: [ 'No restriction', 'Last 2 weeks', 'Last month', 'Last 3 months', 'Last year' ],
		},
	},
	general: {
		months: {
			de: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
			en: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
		},
	},
	teaser: {
		category: {
			de: "Veranstaltung",
			en: "Event",
		},
		readMore: {
			de: "Weiterlesen",
			en: "Read more",
		},
	},
	resultList: {
		labelReadMore: {
			de: "Weiterlesen",
			en: "Read more",
		},
		labelResultCountSingular: {
			de: "Ergebnis",
			en: "result",
		},
		labelResultCountPlural: {
			de: "Ergebnisse",
			en: "results",
		},
		labelNoResults: {
			de: "Keine Einträge gefunden",
			en: "No results found",
		},
		labelPrevious: {
			de: "Zurück",
			en: "previous",
		},
		labelNext: {
			de: "Vor",
			en: "next",
		},
		ariaLabelPage: {
			de: "Seite",
			en: "Page",
		},
	},
};

export default translations;
